import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Stamp = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="352" viewBox="0 0 265 352" width="265" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        d="M260.6 285.6c-1.71-28.86-55.17-47.61-124.27-43.5S12.61 272.96 14.32 301.82c1.73 28.86 46.46 51.59 128.07 49.4 78.7-2.1 119.91-36.76 118.21-65.62Zm-117.67 51.77c-59.1 3.54-109.02-11.94-110.48-36.62-1.49-24.68 45.25-47.57 104.35-51.08 59.1-3.52 98.71 12.49 100.17 37.17s-34.91 47.01-94.03 50.53z"
        fill={shades.black}
      />
      <path
        d="M208.68 284.31c-2.15 9.65-14.38 14.43-14.38 14.43l-23.88-7.71s15.07-2.48 10.17-11.61c-5.79-10.85-51.31-11.24-70.72-4.66-7.48 2.55-24.89 9.52-23.34 20.34.77 5.42 12.96 11.23 28.27 12.15 15.18.93 33.45-2.98 33.45-2.98l22.67 7.61c-.5 0-19.86 7.16-39.98 8.04-21.88.95-42.42-3.63-50.57-6.95-21.39-8.75-17.42-24.45-9.69-32.41 20.87-21.44 75.02-22.52 89.63-21.28 31.1 2.67 50.48 15.38 48.36 25.03z"
        fill={shades.black}
      />
      <path
        className={strokeStyle}
        d="M263.09 193.97c-2.05 14.75-18.65 30.1-44.25 42.72-20.96 10.36-47.95 18.89-77.97 23.77-32.63 5.35-63.23 5.47-87.39 1.39-15.78-13.64-16.97-27.93.99-43.05 24.03 3.91 54.22 3.7 86.4-1.56 30.01-4.92 57.01-13.45 77.97-23.77a172 172 0 0 0 10.45-5.61c9.29-5.4 16.94-11.15 22.65-17.07 6.21-6.45 10.07-13.07 11.11-19.61v36.26q.5 3.24.05 6.52z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M263.04 151.19c-1.03 6.54-4.9 13.16-11.11 19.61-5.71 5.92-13.36 11.68-22.65 17.07a172 172 0 0 1-10.45 5.61c-20.96 10.33-47.95 18.86-77.97 23.77-32.18 5.26-62.38 5.47-86.4 1.56-17.88-2.92-32.33-8.11-41.58-15.22-6.19-4.74-10.07-10.34-11.11-16.67-3.52-21.6 27.01-45.63 73.42-61.12a316 316 0 0 1 48.75-11.9c72.16-11.8 134.43 1.77 139.1 30.31q.54 3.45 0 6.97z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M53.48 261.86c-29.29-4.92-49.15-16.07-51.7-31.69v-43.25c1.03 6.33 4.92 11.93 11.11 16.67 9.25 7.11 23.7 12.29 41.58 15.22-17.96 15.13-16.77 29.41-.99 43.05Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M137.79 182c35.71-5.83 62.52-23.67 59.88-39.84s-33.74-24.55-69.45-18.72-62.52 23.68-59.88 39.85 33.74 24.55 69.45 18.71Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M195.64 25.38c-1.65 9.68-14.26 18.53-34.4 24.7h-.03a183 183 0 0 1-24.39 5.58c-15.17 2.5-30.71 3.45-44.04 2.76-19.01-.99-33.5-5.38-35.9-13.63l-.03-.05q-.1-.5-.24-1c-1.5-9.31 8.24-20.28 24.94-28.68 10.07-5.1 22.68-9.26 36.89-11.57 37.75-6.19 74.79 2.68 77.23 17.6q.37 2.16-.03 4.29Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        d="M140.29 31.89c3.64-3.3 1.6-6.54-5.02-8.04-7.54-1.71-16.8-.27-22.04 3.34-5.17 3.57-3.66 7.47 3.88 9.17 6.63 1.5 14.74.55 20.03-2.32l-8.17-1.84c-1.8.67-4.38.91-6.46.45-3.01-.69-3.31-2.31-1.35-3.66 2.02-1.39 5.65-2.07 8.65-1.39 2.08.48 2.94 1.44 2.31 2.43zm0 0c3.64-3.3 1.6-6.54-5.02-8.04-7.54-1.71-16.8-.27-22.04 3.34-5.17 3.57-3.66 7.47 3.88 9.17 6.63 1.5 14.74.55 20.03-2.32l-8.17-1.84c-1.8.67-4.38.91-6.46.45-3.01-.69-3.31-2.31-1.35-3.66 2.02-1.39 5.65-2.07 8.65-1.39 2.08.48 2.94 1.44 2.31 2.43zm0 0c3.64-3.3 1.6-6.54-5.02-8.04-7.54-1.71-16.8-.27-22.04 3.34-5.17 3.57-3.66 7.47 3.88 9.17 6.63 1.5 14.74.55 20.03-2.32l-8.17-1.84c-1.8.67-4.38.91-6.46.45-3.01-.69-3.31-2.31-1.35-3.66 2.02-1.39 5.65-2.07 8.65-1.39 2.08.48 2.94 1.44 2.31 2.43zm0 0c3.64-3.3 1.6-6.54-5.02-8.04-7.54-1.71-16.8-.27-22.04 3.34-5.17 3.57-3.66 7.47 3.88 9.17 6.63 1.5 14.74.55 20.03-2.32l-8.17-1.84c-1.8.67-4.38.91-6.46.45-3.01-.69-3.31-2.31-1.35-3.66 2.02-1.39 5.65-2.07 8.65-1.39 2.08.48 2.94 1.44 2.31 2.43zm0 0c3.64-3.3 1.6-6.54-5.02-8.04-7.54-1.71-16.8-.27-22.04 3.34-5.17 3.57-3.66 7.47 3.88 9.17 6.63 1.5 14.74.55 20.03-2.32l-8.17-1.84c-1.8.67-4.38.91-6.46.45-3.01-.69-3.31-2.31-1.35-3.66 2.02-1.39 5.65-2.07 8.65-1.39 2.08.48 2.94 1.44 2.31 2.43z"
        fill={shades.black}
      />
      <path
        d="M146.1 16.32c-15.25-3.46-36.56-.46-47.97 7.41-3.48 2.4-5.52 4.89-6.22 7.29-1.6 5.44 3.67 10.42 14.27 12.83a66 66 0 0 0 16.61 1.36c11.71-.45 23.74-3.52 31.36-8.78 11.42-7.87 7.2-16.65-8.05-20.1zm.74 18.45c-8.36 5.77-24.51 8.08-35.66 5.56-11.09-2.52-14.2-9.19-5.82-14.98 8.38-5.77 24.52-8.08 35.6-5.58 11.15 2.53 14.26 9.2 5.88 14.99z"
        fill={shades.black}
      />
      <path className={strokeStyle} d="M97.62 152.93v1.76a5 5 0 0 1 0-1.76Z" fill={shades.secondary.medium} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M130.29 163.34c-17.28 1.98-31.54-1.63-32.68-8.65v-1.77l-.07-53.73c-23.55-6.7-34.57-27.78-40.67-54.4 2.4 8.24 16.89 12.64 35.9 13.63 3.03 7.94 11.11 26.07 24.42 35.75 7.66 5.58 11 23.21 12.31 41.18.76 9.86.9 19.83.79 27.99Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m163.31 96.47 3.88 46.86c1.24 7.6-13.33 16.28-32.54 19.43q-2.22.37-4.36.58c.1-8.15-.03-18.12-.79-27.99-1.3-17.97-4.65-35.6-12.31-41.18-13.31-9.68-21.39-27.81-24.42-35.75 13.33.69 28.87-.25 44.04-2.76a181 181 0 0 0 24.39-5.58h.03c20.15-6.18 32.75-15.02 34.4-24.7-.46 31.6-6.88 56.17-32.32 71.08z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
